import { getLatLng } from '@api/google'
import { LaneInfo } from '@components/shared/LaneInfo'
import { calculateSphericalDistance } from '@utils/calculateSphericalDistance'

const METERS_TO_MILES_RATIO = 0.000621371192
const SEARCH_RADIUS_IN_MILES = 100

export type EnrollmentLocation = {
  airportCode: string
  name: string
  address: string
  location: any
  distance: number
  hours: string
  lanes: LaneInfo[]
  important_info?: string
  open?: boolean
}

export const determineMapZoomLevel = (
  locationsWithinRange: EnrollmentLocation[]
) => {
  const largestDistance = locationsWithinRange.reduce((acc, location) => {
    if (location?.distance > acc) acc = location?.distance
    return acc
  }, 0)

  return largestDistance > 20 ? 8 : largestDistance > 9 ? 10 : undefined
}

export const getNearbyEnrollmentLocations = async (
  enrollmentLocations: Record<string, any>,
  searchInput: string
) => {
  const searchCoords = await getLatLng(searchInput, enrollmentLocations)

  const enrollmentLocationsNearSearch: EnrollmentLocation[] = Object.values(
    enrollmentLocations
  )
    .map((enrollmentLocation: any) => {
      const distanceInMeters = calculateSphericalDistance(
        searchCoords as any,
        enrollmentLocation?.coordinates
      )
      const distanceInMiles = distanceInMeters * METERS_TO_MILES_RATIO
      const roundedDistanceInMiles = Math.round(distanceInMiles * 10) / 10

      return {
        airportCode: enrollmentLocation?.uid,
        distance: roundedDistanceInMiles,
        name: enrollmentLocation?.name,
        location: {
          lat: Number(enrollmentLocation.coordinates.lat),
          lng: Number(enrollmentLocation.coordinates.lng),
        },
        address: enrollmentLocation?.address,
        hours: enrollmentLocation?.hours,
        lanes: enrollmentLocation?.lanes,
        open: enrollmentLocation?.open,
        important_info: enrollmentLocation?.important_info,
      }
    })
    // return enrollment locations within SEARCH_RADIUS_IN_MILES miles
    .filter(
      (enrollmentLocation) =>
        enrollmentLocation.distance < SEARCH_RADIUS_IN_MILES
    )
  return { enrollmentLocationsNearSearch, location }
}
